module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('section', {
    staticClass: "comment-rate"
  }, [_c('p', {
    staticClass: "comment-rate-font ma2"
  }, [_vm._v(_vm._s(_vm.commentMedian || 0))]), _vm._v(" "), _c('p', {
    staticClass: "ma1 fw6 f3"
  }, [_vm._v("Median Comments")]), _vm._v(" "), _c('p', {
    staticClass: "ma1 mt2 fw6 f3"
  }, [_vm._v("Per Student")])]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "margin-right": "-30px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_info_comment_rate = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })])], 1), _vm._v(" "), (_vm.show_info_comment_rate) ? _c('pl-dialog', {
    on: {
      "close": function($event) {
        _vm.show_info_comment_rate = false
      }
    }
  }, [_c('p', {
    staticClass: "italics pl-subheading tc"
  }, [_vm._v("\n      This is the median number of comments per student in the RoundTable.\n    ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.show_info_comment_rate = false
      }
    }
  }, [_vm._v("\n      OK\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-148baff6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/roundtableSummary/roundtableSummaryCommentRate.vue
// module id = 1218
// module chunks = 61